import Base from 'base.service';

export default class Auth extends Base {
  constructor ($http, $cookies, $q) {
    'ngInject';

    super($http);
    this.$cookies = $cookies;
    this.$q = $q;
    this.path = '/auth.json';
  }

  login(credentials) {
    return this.$http.post(this.apiUrl + this.path,  credentials)
      .then((response) => {
        const token = response.data.access_token;
        this.$cookies.put('token', token);
        return response;
      });
  }

  logout() {
    const unauthenticatedUser = this.currentUser;
    this.currentUser = null;
    this.$cookies.remove('token');

    return this.$q.when(unauthenticatedUser);
  }

  getCurrentUser() {
    if (this.currentUser) {
      return this.$q.when(this.currentUser);
    }

    if (this.isTokenPresent()) {
      return this.$http.get(this.apiUrl + this.path)
      .then((response) => {
        this.currentUser = response.data.engineer;

        return this.currentUser;
      });
    } else {
      return this.$q.reject('Token is missed');
    }
  }

  isAuthenticated() {
    return !!this.currentUser;
  }

  isTokenPresent() {
    return !!this.$cookies.get('token');
  }
}



// WEBPACK FOOTER //
// ./src/app/util/auth.service.js